// Argus — cameras helper. Bloc ws-direct-batch-2 2026-05-05: WS direct flow.
// Mapping de la WS CameraInfo (cu supportedResolutions) la existing CameraDevice
// (cu supportedModes) pentru a păstra compatibilitatea caller-ilor.

import { wsClient, WsAgentOfflineError } from './wsClient';
import type { CameraDevice } from './enumDevices';

export interface FetchCamerasResult {
  cameras: CameraDevice[];
  artifactId: string | null;
}

/**
 * Bloc ws-direct-batch-2 2026-05-05: WS direct enumerate cu fallback la error UI.
 * Drop disk artifact + REST flow polling.
 */
export async function fetchAgentCameras(agentId: string): Promise<FetchCamerasResult> {
  try {
    const result = await wsClient.requestEnumerateDevices(agentId);
    const cameras: CameraDevice[] = result.cameras.map((c) => ({
      id: c.deviceId,
      friendlyName: c.name,
      isDefault: false,
      supportedModes: c.supportedResolutions.map((r) => ({
        width: r.width,
        height: r.height,
        fps: r.fps,
        format: '',
      })),
      error: null,
    }));
    return { cameras, artifactId: null };
  } catch (err) {
    if (err instanceof WsAgentOfflineError) {
      // TODO: fallback la DB cache `agent_device_snapshots` (REST endpoint nou) când agent offline.
      throw err;
    }
    throw err;
  }
}
